<template>
	<div id="security_index_school">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{ screenName }}</dv-decoration-9></div>
				<div class="d-flex jc-center title_bg"></div>
				<div class="safe_left">
					<div class="campus_safetit"><img src="../../assets/img/camera_icon.png"><b>录像设备</b>（点击列表可查看）</div>
					<div class="line_bg" style="max-width:300px"></div>
					<ul>
						<li :class="activeClass == index ? 'on' : ''" v-for="(device, index) in securityList" :key="index" @click="openView(index, device.lanAddress, device.lanPort)">{{ device.deviceName }}</li>
					</ul>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
export default {
	data() {
		return {
			loading: true,
			fullscreen: false,
			screenName: "全屏",
			securityList: [],
			activeClass: 0
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/security/getSecurityInfo?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.securityList = result;
					}
				}
			});
		},
		//打开观看端画面
		openView(index, pubAddress, pubPort) {
			let _this = this;
			_this.activeClass = index;
			window.open('http://' + pubAddress + ':' + pubPort, '_blank');
		},
		//点击全屏
		screen: function () {
			let _this = this;
			let element = document.documentElement;
			if (_this.fullscreen) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				_this.screenName = "全屏";
			} else {
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();
				}
				_this.screenName = "取消";
			}
			_this.fullscreen = !_this.fullscreen;
		}
	}
};
</script>

<style lang="scss">
#security_index_school {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/campussafe_bg.jpg");
	background-size: 100% 100%;

	.full_screen {
		width: 0.8rem;
		height: 0.8rem;
		position: absolute;
		top: 0.32rem;
		right: 0.5rem;
		font-size: 0.2rem;
		color: #55ffff;
		font-weight: bold;
		-webkit-background-clip: text;
		background-image: linear-gradient(90deg, #55ffff, #55aaff);
		-webkit-text-fill-color: transparent;
		cursor: pointer;
	}

	.bg {
		padding: 0.2rem 0.2rem 0 0.2rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 10vh;
		background: url("../../assets/img/campussafe_titbg.png") center no-repeat;
	}

	.search input[type=text] {
		width: 3rem;
		height: 0.5rem;
		padding-left: 0.2rem;
		font-size: 0.2rem;
		border: 2px solid #55ffff;
		float: left;
		color: #55ffff;
		background: none;
	}

	.search input:-moz-placeholder {
		color: #55ffff;
	}

	.search input:-ms-input-placeholder {
		color: #55ffff;
	}

	.search input::-webkit-input-placeholder {
		color: #55ffff;
	}

	.search button {
		float: left;
		width: 0.5rem;
		height: 0.5rem;
		padding: 10px;
		border: 2px solid #55ffff;
		background: #266bff url("../../assets/img/search_icon.png") center no-repeat;
		background-size: 50%;
		border-left: none;
		cursor: pointer;
	}

	.search button:hover {
		border: 2px solid #4599ff;
		background: #4599ff url("../../assets/img/search_icon.png") center no-repeat;
		background-size: 50%;
		border-left: none;
	}

	.search::after {
		content: "";
		clear: both;
		display: table;
	}

	.line_bg {
		height: 0.03rem;
		background-image: linear-gradient(to right, rgba(0, 240, 244, 0.6), rgba(33, 209, 244, 0.3), rgba(0, 240, 244, 0));
		margin: 0.2rem 0;
	}

	.campus_safetit {
		font-size: 0.18rem;
		color: #55ffff;
		margin-bottom: 0.2rem;
	}

	.campus_safetit b {
		font-size: 0.25rem;
	}

	.campus_safetit img {
		width: 0.3rem;
		margin-right: 0.05rem;
		vertical-align: middle;
	}

	.safe_left {
		float: left;
		margin: 0.3rem 0 0 1rem;
	}

	.safe_left ul {
		height: 65vh;
		overflow-y: auto;
	}

	.safe_left ul li {
		width: fit-content;
		padding: 0.1rem 0.2rem;
		margin: 0 0 0.2rem 0;
		position: relative;
		color: #55ffff;
		font-size: 0.22rem;
		border-left: 3px solid #55ffff;
		background-image: linear-gradient(to right, rgba(33, 209, 244, 0.6), rgba(0, 240, 244, 0.2), rgba(0, 240, 244, 0));
	}

	.safe_left ul li:hover,
	.safe_left ul li.on {
		background-image: linear-gradient(to right, rgba(42, 52, 244, 0.8), rgba(123, 63, 244, 0.8), rgba(41, 105, 244, 0));
	}

	.safe_left ul li:hover {
		cursor: pointer;
	}

	.safe_left ul::-webkit-scrollbar {
		width: 2px;
	}

	.safe_left ul::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.safe_left ul::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}
}</style>